import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, SITE } from "../lib/data";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "glass py-3" : "py-6 bg-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <button
          onClick={() => handleNav("hero")}
          className="flex items-center gap-3 group"
          data-testid="logo-button"
        >
          <div className="w-9 h-9 border border-[var(--pw-gold)] flex items-center justify-center text-[var(--pw-gold)] font-serif text-lg italic group-hover:bg-[var(--pw-gold)] group-hover:text-black transition-colors duration-500">
            P
          </div>
          <div className="hidden sm:flex flex-col leading-tight">
            <span className="font-serif text-lg tracking-wider text-[var(--pw-text)]">
              Proscenio
            </span>
            <span className="text-[10px] uppercase tracking-[0.3em] text-[var(--pw-gold)]">
              Wedding
            </span>
          </div>
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <button
              key={link.id}
              onClick={() => handleNav(link.id)}
              className="text-xs uppercase tracking-[0.22em] text-[var(--pw-text)]/70 hover:text-[var(--pw-gold)] transition-colors duration-300"
              data-testid={`nav-link-${link.id}`}
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:block">
          <button
            onClick={() => handleNav("contatti")}
            className="btn-pw"
            data-testid="nav-cta-button"
          >
            Preventivo
          </button>
        </div>

        <button
          onClick={() => setOpen((s) => !s)}
          className="lg:hidden text-[var(--pw-text)] p-2"
          aria-label="Menu"
          data-testid="menu-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4 }}
            className="lg:hidden overflow-hidden bg-black/95 backdrop-blur-xl border-t border-[var(--pw-border)]"
            data-testid="mobile-menu"
          >
            <div className="px-6 py-6 flex flex-col gap-4">
              {NAV_LINKS.map((link) => (
                <button
                  key={link.id}
                  onClick={() => handleNav(link.id)}
                  className="text-left text-sm uppercase tracking-[0.22em] text-[var(--pw-text)]/80 hover:text-[var(--pw-gold)] py-2 border-b border-white/5"
                  data-testid={`mobile-nav-${link.id}`}
                >
                  {link.label}
                </button>
              ))}
              <a
                href={`tel:${SITE.phone2.replace(/\./g, "")}`}
                className="text-[var(--pw-gold)] text-sm tracking-widest mt-2"
                data-testid="mobile-phone"
              >
                {SITE.phone2}
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export default Navbar;
